<template>
<div :class="getStatusHeader.header.minimaze ? 'grid__content' : 'grid__content-minimaze grid__content' ">
	<div class='grid__navigator'
        :class="getStatusNavigator">
            <div v-if="!leftNavigator" class="navigator__eventViewer">
                <event-viewer></event-viewer>
            </div>
            <transition enter-active-class="animated fadeIn"
                            leave-active-class="animated slideOutLeft" mode="out-in">
            <div class="navigator__head" v-show="leftNavigator">
                <div class="navigator__instruments">
                    <div class="navigator__icon" @click="navMenuSwitcher">
						<svg-icon v-if="navMenu" icon-class="icon icon--inline icon-menu" icon-name="icon-menuopen" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
						<svg-icon v-if="!navMenu" icon-class="icon icon--inline icon-menu" icon-name="icon-menu" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
                    </div>
                    <div class="navigator__title" @click="switchInstruments">{{$t(activeItem)}}</div>
                </div>
                <div class="navigator__title-chat">
                    <div class="navigator__icon navigator__icon-chat">
						<svg-icon  icon-class="icon icon--inline icon-chat" icon-name="icon-chat" icon-size="0 0 42 42" icon-fill="#718DA8"></svg-icon>
					</div>
                    <div class="navigator__title-chat-text" @click="switchChat">Чат</div>
                </div>
            </div>
            </transition>
            <transition
                enter-active-class="animated fadeInDown"
                leave-active-class="animated fadeOut">
                <div class="navigator__menu" v-show="navMenu">
                    <drag-container v-model="navigator" @input="setSorting">
                        <drag-item class='navigator__item' v-for="(item,index) in navigator" :key="index" :index="index"
                        :item="item.name"
                            :status="item.statusActive" @changeSwitch = "switchSelector($event,index)">
                        </drag-item>
                    </drag-container>
                </div>
            </transition>
            <scrollbar class="navigator_tab" :settings="settings" v-show="navTab">
                <transition enter-active-class="animated fadeIn"
                            leave-active-class="animated fadeOut" mode="out-in">

                    <div class="navigator__wrap" v-show="leftNavigator">
                        <videoWidget :options="videoOptions" />

                        <drag-container v-model="navigator">
                            <drag-item class="navigator__widget" v-for="(item,index) in navigator" :key="index" :index="index" :is="item.component"
                             v-show="item.statusActive" />
                        </drag-container>
                        <!--<transition enter-active-class="animated fadeIn"
                            leave-active-class="animated fadeOut"
                            mode="out-in">
                            <div class="navigator__widget"
                                :data-target="target[3].data"
                                v-if="target[3].visible">
                            <chart-widget
                                    :balance = "summaryBalance.toLocaleString('en')"
                                    :leverage = "lastDailyLeverage"
                                    :leverageMax = "lastDailyLeverageMax"
                            ></chart-widget>
                            </div>
                        </transition>-->
                    </div>
                </transition>
            </scrollbar>
            <scrollbar v-show="!navTab">
                <div :class="getStatusHeader ? 'navigator__chat' : 'navigator__chat-minimaze'">
                    <chat-navigator v-show="leftNavigator"></chat-navigator>
                </div>
            </scrollbar>
    </div>
    <div class="grid__main-content">
        <div style="position:absolute; top:2px; right: 6px; z-index:3;">
            <a href="https://devdcas.toptrader.org/233FC17FA78B4B589D26CF6730A37639" target="_blank"><svg width="180" height="40" viewBox="0 0 180 40" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_dd)"><g filter="url(#filter1_i)"><rect x="3" y="2" width="174" height="32" rx="4" fill="url(#paint0_linear)"></rect></g><g filter="url(#filter2_i)"><path d="M3 6C3 3.79086 4.79086 2 7 2H69V34H7C4.79086 34 3 32.2091 3 30V6Z" fill="url(#paint1_linear)"></path></g><path d="M19.104 13.776H15.072V11.4H26.052V13.776H22.02V24H19.104V13.776ZM34.6272 24.216C33.3192 24.216 32.1372 23.934 31.0812 23.37C30.0372 22.806 29.2152 22.032 28.6152 21.048C28.0272 20.052 27.7332 18.936 27.7332 17.7C27.7332 16.464 28.0272 15.354 28.6152 14.37C29.2152 13.374 30.0372 12.594 31.0812 12.03C32.1372 11.466 33.3192 11.184 34.6272 11.184C35.9352 11.184 37.1112 11.466 38.1552 12.03C39.1992 12.594 40.0212 13.374 40.6212 14.37C41.2212 15.354 41.5212 16.464 41.5212 17.7C41.5212 18.936 41.2212 20.052 40.6212 21.048C40.0212 22.032 39.1992 22.806 38.1552 23.37C37.1112 23.934 35.9352 24.216 34.6272 24.216ZM34.6272 21.732C35.3712 21.732 36.0432 21.564 36.6432 21.228C37.2432 20.88 37.7112 20.4 38.0472 19.788C38.3952 19.176 38.5692 18.48 38.5692 17.7C38.5692 16.92 38.3952 16.224 38.0472 15.612C37.7112 15 37.2432 14.526 36.6432 14.19C36.0432 13.842 35.3712 13.668 34.6272 13.668C33.8832 13.668 33.2112 13.842 32.6112 14.19C32.0112 14.526 31.5372 15 31.1892 15.612C30.8532 16.224 30.6852 16.92 30.6852 17.7C30.6852 18.48 30.8532 19.176 31.1892 19.788C31.5372 20.4 32.0112 20.88 32.6112 21.228C33.2112 21.564 33.8832 21.732 34.6272 21.732ZM50.2467 11.4C51.3627 11.4 52.3287 11.586 53.1447 11.958C53.9727 12.33 54.6087 12.858 55.0527 13.542C55.4967 14.226 55.7187 15.036 55.7187 15.972C55.7187 16.896 55.4967 17.706 55.0527 18.402C54.6087 19.086 53.9727 19.614 53.1447 19.986C52.3287 20.346 51.3627 20.526 50.2467 20.526H47.7087V24H44.7927V11.4H50.2467ZM50.0847 18.15C50.9607 18.15 51.6267 17.964 52.0827 17.592C52.5387 17.208 52.7667 16.668 52.7667 15.972C52.7667 15.264 52.5387 14.724 52.0827 14.352C51.6267 13.968 50.9607 13.776 50.0847 13.776H47.7087V18.15H50.0847Z" fill="black"></path><path d="M85.104 13.776H81.072V11.4H92.052V13.776H88.02V24H85.104V13.776ZM102.729 24L100.299 20.49H100.155H97.617V24H94.701V11.4H100.155C101.271 11.4 102.237 11.586 103.053 11.958C103.881 12.33 104.517 12.858 104.961 13.542C105.405 14.226 105.627 15.036 105.627 15.972C105.627 16.908 105.399 17.718 104.943 18.402C104.499 19.074 103.863 19.59 103.035 19.95L105.861 24H102.729ZM102.675 15.972C102.675 15.264 102.447 14.724 101.991 14.352C101.535 13.968 100.869 13.776 99.993 13.776H97.617V18.168H99.993C100.869 18.168 101.535 17.976 101.991 17.592C102.447 17.208 102.675 16.668 102.675 15.972ZM117.315 21.3H111.465L110.349 24H107.361L112.977 11.4H115.857L121.491 24H118.431L117.315 21.3ZM116.397 19.086L114.399 14.262L112.401 19.086H116.397ZM123.879 11.4H129.603C130.971 11.4 132.177 11.664 133.221 12.192C134.277 12.708 135.093 13.44 135.669 14.388C136.257 15.336 136.551 16.44 136.551 17.7C136.551 18.96 136.257 20.064 135.669 21.012C135.093 21.96 134.277 22.698 133.221 23.226C132.177 23.742 130.971 24 129.603 24H123.879V11.4ZM129.459 21.606C130.719 21.606 131.721 21.258 132.465 20.562C133.221 19.854 133.599 18.9 133.599 17.7C133.599 16.5 133.221 15.552 132.465 14.856C131.721 14.148 130.719 13.794 129.459 13.794H126.795V21.606H129.459ZM149.586 21.66V24H139.83V11.4H149.352V13.74H142.728V16.476H148.578V18.744H142.728V21.66H149.586ZM161.014 24L158.584 20.49H158.44H155.902V24H152.986V11.4H158.44C159.556 11.4 160.522 11.586 161.338 11.958C162.166 12.33 162.802 12.858 163.246 13.542C163.69 14.226 163.912 15.036 163.912 15.972C163.912 16.908 163.684 17.718 163.228 18.402C162.784 19.074 162.148 19.59 161.32 19.95L164.146 24H161.014ZM160.96 15.972C160.96 15.264 160.732 14.724 160.276 14.352C159.82 13.968 159.154 13.776 158.278 13.776H155.902V18.168H158.278C159.154 18.168 159.82 17.976 160.276 17.592C160.732 17.208 160.96 16.668 160.96 15.972Z" fill="black"></path></g><defs><filter id="filter0_dd" x="0" y="0" width="180" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="3"></feOffset><feGaussianBlur stdDeviation="1.5"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset></feOffset><feGaussianBlur stdDeviation="1"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"></feColorMatrix><feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter><filter id="filter1_i" x="3" y="2" width="174" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow"></feBlend></filter><filter id="filter2_i" x="3" y="2" width="66" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.971748 0 0 0 0 0.620833 0 0 0 1 0"></feColorMatrix><feBlend mode="normal" in2="shape" result="effect1_innerShadow"></feBlend></filter><linearGradient id="paint0_linear" x1="90" y1="2" x2="90" y2="34" gradientUnits="userSpaceOnUse"><stop stop-color="#FAFAFA"></stop><stop offset="1" stop-color="#E9E9E9"></stop></linearGradient><linearGradient id="paint1_linear" x1="36" y1="2" x2="36" y2="34" gradientUnits="userSpaceOnUse"><stop stop-color="#FFF100"></stop><stop offset="1" stop-color="#FFCE00"></stop></linearGradient></defs></svg></a>
        </div>
        <scrollbar class='content-wrapper'>
            <timer v-if="showBannerCloseMarket"></timer>
                <tabs :classTabs = "'mainNavigation'"
                    :classNavigation = "'main-head'"
                    :classItem = "'main-head__tab'"
                    :classActive="'main-head__tab-active'"
                    @setTabs="setSatusLeftNavigator($event)">
                    <tab :name="'Доход'" :selected="true" ref="profit">
                        <tabs :classTabs = "'subNavigation'"
                            :classNavigation = "'main-head'"
                            :classItem = "'main-head__tab'"
                            :classActive="'main-head__tab-active'"
                            @setTabs="setSatusLeftNavigator($event)">
                            <tab :name="'Доход, %'" :selected="true" >
								<strategy
									:updateHight="subContent"
									:updateRight="rightChat"
									:fullStatus="false"
								>
								</strategy>
                            </tab>
                            <tab :name="'Доход инвестора'">
                                    <grid-strategy
                                        :updateHight="subContent"
                                        :updateRight="rightChat"
                                    >
                                    </grid-strategy>
                            </tab>
                            <tab :name="'МЕСЯЦ'" ref="month">
								<month-chart
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat">
								</month-chart>
                            </tab>
                            <tab :name="'НЕДЕЛЯ'" ref="week">
								<week-chart
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat">
								</week-chart>
                            </tab>
                            <tab :name="'ДЕНЬ'" ref="day">
								<day-chart
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat">
								</day-chart>
                            </tab>
                            <tab :name="'ПРОГНОЗ НА МЕСЯЦ'" ref="day">
								<PrognosisNew
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat">
								</PrognosisNew>
                            </tab>
                            <tab :name="'Доход в % по месяцам'">
								<gistagram
									:updateHight="subContent"
									:updateRight="rightChat">
								</gistagram>
                            </tab>
                            <tab :name="'Калькулятор дохода'">
								<calculator/>
                            </tab>
                                        <!--<tab :name="'Месяц'">
                                            <div class="grid-month">
                                                <sig-month></sig-month>
                                                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                            </div>
                                        </tab>-->
                        </tabs>
                    </tab>
                    <!--<tab :name="'+'" ref="plus">
                        <div :class="subContent ? 'grid' : 'grid grid-full'">
                            <grid
                                :update="leftNavigator"
                                :updateRight="rightChat"
                                :updateHeight="subContent">
                            </grid>
                        </div>
                    </tab>-->
                    <tab :name="'Баланс / Средства'">
						<grid-single
							:update="leftNavigator"
							:updateRight="rightChat"
							:updateHeight="subContent"
							:resize="resize"
							:symbol="''">
						</grid-single>
                    </tab>
                    <tab :name="'Прогноз'" ref="prognosis">
						<prognosis-chart
							:updateRight="rightChat"
							:updateHeight="subContent">
						</prognosis-chart>
                    </tab>
                    <tab :name="'30 дней'">
						<grid-last-days
							:update="leftNavigator"
							:updateRight="rightChat"
							:updateHeight="subContent"
							:symbol="''">
						</grid-last-days>
                    </tab>
                    <tab :name="'Пары'" ref="pairs">
                        <tabs :classTabs = "'subNavigation'"
                            :classNavigation = "'main-head'"
                            :classItem = "'main-head__tab'"
                            :classActive="'main-head__tab-active'">
                            <tab :name="`EURUSD ${getCounter[0]}`"
                                :selected="true">
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'EURUSD'"
									:resize="resize">
								</grid-single>
                            </tab>
                            <tab :name="`GBPUSD ${getCounter[1]}`" >
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'GBPUSD'"
									:resize="resize">
								</grid-single>
                            </tab>
							<tab :name="`USDJPY ${getCounter[2]}`" >
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'USDJPY'"
									:resize="resize">
								</grid-single>
							</tab>
							<tab :name="`USDCHF ${getCounter[3]}`" >
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'USDCHF'"
									:resize="resize">
								</grid-single>
							</tab>
							<tab :name="`USDCAD ${getCounter[4]}`" >
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'USDCAD'"
									:resize="resize">
								</grid-single>
							</tab>
							<tab :name="`EURGBP ${getCounter[5]}`" >
								<grid-single
									:update="leftNavigator"
									:updateRight="rightChat"
									:updateHeight="subContent"
									:symbol="'EURGBP'"
									:resize="resize">
								</grid-single>
							</tab>
						</tabs>
                    </tab>
					<tab :name="'СРАВНЕНИЕ'" ref="compare">
						<compare
							:update="leftNavigator"
							:updateRight="rightChat"
							:updateHeight="subContent"
							:resize="resize">
						</compare>
					</tab>

					<tab :name="'СДЕЛКИ НА ГРАФИКЕ'">
						<tabs :classTabs = "'subNavigation'"
							:classNavigation = "'main-head'"
							:classItem = "'main-head__tab'"
							:classActive="'main-head__tab-active'">
							<tab :name="'EUR/USD'" :selected="true">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'EURUSD'">
								</candlesTick>
							</tab>
							<tab :name="'GBP/USD'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'GBPUSD'">
								</candlesTick>
							</tab>
							<tab :name="'USD/JPY'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'USDJPY'">
								</candlesTick>
							</tab>
							<tab :name="'USD/CHF'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'USDCHF'">
								</candlesTick>
							</tab>
							<tab :name="'EUR/GBP'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'EURGBP'">
								</candlesTick>
							</tab>
							<tab :name="'USD/CAD'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'USDCAD'">
								</candlesTick>
							</tab>
							<tab :name="'AUD/USD'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'AUDUSD'">
								</candlesTick>
							</tab>
							<tab :name="'NZD/USD'">
								<candlesTick
									:update="leftNavigator"
									:updateHight="subContent"
									:updateRight="rightChat"
									:symbolInst="'NZDUSD'">
								</candlesTick>
							</tab>
						</tabs>
					</tab>
				</tabs>
                    <!--<div class="fullScreen" @click="fullscreen">
                        <i :class="fullScreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'"></i>
                    </div>-->
                    <!--<div class="autoSwitchTabs">
                        <div :class="autoTabs ? 'autoSwitchTabs__text color-green' : 'autoSwitchTabs__text color-red'" >
                            auto
                        </div>
                        <switcher @switchStatus = "slideTabs($event)" :classSwitcher = "autoTabs"></switcher>
                    </div>-->
                    <div class="sub-content">
                        <subcontent
                        :balance="summaryBalance.toLocaleString('en')"
                        :show = "subContent"
                        @show = "onShowSubContent"></subcontent>
                    </div>
            </scrollbar>
        </div>
    <div class="grid__chat">
        <div class="right-block" v-show="rightChat">
            <div class="main-head-chat">
                <div :class="rightChatWidget ? 'main-head-chat__title main-head-chat__title-active' : 'main-head-chat__title'" @click="showRightChat">
                    ЧАТ
                    <span>Прямой эфир</span>
                </div>
                <div :class="rightNews ? 'main-head-chat__title main-head-chat__title-active' : 'main-head-chat__title'" @click="showNews">
                    Новости
                </div>
            </div>
            <scrollbar v-show="rightNews">
                <div :class="getStatusHeader.header.minimaze ? 'right-block-widgets-wrap' : 'right-block-widgets-wrap-minimaze'">
                    <news></news>
                </div>
            </scrollbar>
            <chat-widget v-if="rightChatWidget"></chat-widget>
        </div>
    </div>
        <div v-if="overlayNavigator"  @click = "closeMenu" class="overlay-navigator"></div>
    </div>
</template>

<script>
import Tab from "../ui-components/ui-tab";
import Tabs from "../ui-components/ui-tabs";
import Calculator from "../calculator/sig-calculator";
import PrognosisNew from "./chartsForTabs/prognosisChart/prognosisChart"
import SigQuoteWidget from "./sig-quote-widget.vue";
import OpenPosition from "./sig-profitability-open-positions-widget";
import LastDaysChart from "../statistica/sig-last-days-widget.vue";
import PrognosisChart from "./sig-chart-widget-progosis";
import MaxDDChart from "./sig-profitability-chart-maxdd";
import SubContent from "./subContent/sig-chart-subcontent";
import Compare from "./compare/sig-compare-profitability";
import WeekChart from "./chartsForTabs/profitWeekCharts/widgetWeekWrapper";
import MonthChart from "./chartsForTabs/profitMonthCharts/widgetMonthWrapper";
import ChartWidget from "./widget-profit-month-and-weeks/sig-profitability-widget-month-and-weeks";
import ProfitGistagram from './sig-gistogramm-widget';
import ProfitStrategy from './chartsForTabs/pofitInPercent/widgetProfitWrapper';
import MonthStatistica from './sig-profitability-static-of-month'
import Switcher from '../ui-components/switcher';
import DragContainer from '../ui-components/drag-container'
import DragItem from '../ui-components/drag-item'
import SummaryTable from './sig-profitability-stat-table';
import { mapGetters } from "vuex";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import WidgetChat from '../chat/chat-vertical-widget';
import WidgetChatNavigator from '../chat/chat-vertical-widget-navigator'
import NewsWidget from './sig-news'
import ClosedPositionsRoundWidget from '../ui-components/persent-of-close-positions';
import SimpleRound from '../ui-components/round-widget';
import TimerBanner from './WeekendDayTimer/sig-timer';
import GridChart from './sig-chart-grid';
import SingleGrid from './sig-single-chart-grid';
import SummaryAccountData from './sig-summary-account-data';
import IncomeWidget from './leftNavigator/income-widget/income-block';
import GridChartsStartegy from './profit-strategy/grid-charts';
import StreamWidget from './leftNavigator/streamWidget/stream-widget-vue';
import TestCandlesTick from './chartsForTabs/candlesTick';
import DayChart from './chartsForTabs/profitDayCharts/widgetWrapper';
import EventViewer from './leftNavigator/event-widget';
import videoWidget from './leftNavigator/newsVideoWidget';
import poster from '../../assets/img/player-splash.png';
import svgIcon from '../ui-components/svg-icon';

export default {
  components: {
    "tabs": Tabs,
    "tab": Tab,
    "news": NewsWidget,
    "grid":GridChart,
    "grid-single":SingleGrid,
    "grid-strategy":GridChartsStartegy,
    "grid-last-days":LastDaysChart,
    "sig-quote-widget": SigQuoteWidget,
    "prognosis-chart": PrognosisChart,
    "maxdd-chart": MaxDDChart,
    "subcontent": SubContent,
    "compare": Compare,
    "week-chart":WeekChart,
    "month-chart":MonthChart,
    "day-chart":DayChart,
    "chart-widget":ChartWidget,
    "gistagram":ProfitGistagram,
    "sig-month":MonthStatistica,
    "switcher":Switcher,
    "summary-table":SummaryTable,
    "scrollbar":VuePerfectScrollbar,
    "chat-widget":WidgetChat,
    "chat-navigator":WidgetChatNavigator,
    "round":ClosedPositionsRoundWidget,
    "simple-round":SimpleRound,
    "timer":TimerBanner,
    "sum-account":SummaryAccountData,
    "open-position": OpenPosition,
    "drag-container": DragContainer,
    "drag-item": DragItem,
    "strategy": ProfitStrategy,
    "income-widgets":IncomeWidget,
    "stream":StreamWidget,
    "candlesTick":TestCandlesTick,
    "event-viewer":EventViewer,
    "calculator":Calculator,
    PrognosisNew,
    videoWidget,
  	svgIcon
  },
  data() {
    return {
        autoTabs:false,
        interval:null,
        navigator: null,
        navTab:true,
        settings: {
            maxScrollbarLength: 120
        },
        target: [],
        navMenu: false,
        tab: false,
        activeItem: 'profitabilityLeftNavigations.title',
        statPrimary:[],
        statEURUSD:[],
        summaryEquity:0,
        summaryBalance:0,
        lastDailyBalance0:0,
        lastDailyBalance1:0,
        lastDailyEquity:0,
        lastDailyEquityMin:0,
        lastDailyEquityMax:0,
        lastDailyLeverage:0,
        lastDailyLeverageMax:0,
        lastPlAbs:0,
        dd:0,
        leverageMax:0,
        summaryBalanceEURUSD:0,
        prognosisMonth:0,
        prognosisSison:0,
        prognosisSixMonth:0,
        prognosisYear:0,
        deals:0,
        profitDeals:0,
        overlayNavigator:false,
        leftNavigator:true,
        statusNavigator:null,
        subContent:true,
        rightChat:true,
        rightChatWidget:true,
        rightNews:false,
        fullScreen:false,
        showPair:[],
        currencyForCounters: ['EURUSD','GBPUSD','USDJPY','USDCHF','USDCAD','EURGBP'],
        resize:true,
        videoOptions: {
			autoplay: true,
			controls: true,
            responsive: true,
			sources: [
				{
					src:"https://e3-online-video.rbc.ru/online2/rbctv_480p/index.m3u8",
					type: "application/x-mpegURL ",
				}
			],
			poster: poster
		}
    };
  },// End Data
    computed: {
        ...mapGetters({
            leftColumnWidgets: "layout/getLeftColumnWidgets",
            name: "auth/getName",
            stat: "accountstat/getPrimaryStatistics",
            getStatusHeader:'usersets/getSettings',
            statusLeftNavigator: 'usersets/getStatusNavigator'
        }),
        getStatusNavigator() {
            if (this.statusNavigator === null) {
                return 'navigatorFull';
            } else if (this.statusNavigator) {
                return 'navigatorFull-anim';
            } else if (!this.statusNavigator) {
                return 'navigatorMinimaze';
            }
        },
        miniNavigatorWidth () {
            let width = {}
            if(this.leftNavigator) {
                width = {
                    widthNav:360,
                }
            }
            else {
                width = {
                    widthNav:40,
                }
            }
            return width;
        },
        getHeader () {
            let heights = {}
            if(this.getStatusHeader) {
                heights= {
                    heightChart:100
                }
            }
            else {
                heights= {
                    heightChart:50
                }
            }
            return heights;
        },
        getChartHeight() {
            let height = null;
            if (this.getStatusHeader & this.subContent) {
                height = 470
            }
            else if (!this.getStatusHeader & this.subContent) {
                height = 470
            }
            else if (!this.getStatusHeader & !this.subContent) {
                height = 304
            }
            else if (this.getStatusHeader & !this.subContent) {
                height = 354
            }
            return height;
        },
        showBannerCloseMarket() {
            let show = null;
            let nowDate = new Date()
            let day = nowDate.getDay();
            if(day == 0 || day == 6)
                show = true
            return show;
        },
        getSortingPair() {
            let positionPair = [
                {
                    pair: pairTrue(this.position.EURUSD),
                    title:'EURUSD',
                    show:true
                },
                {
                    pair: pairTrue(this.position.GBPUSD),
                    title:'GBPUSD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDJPY),
                    title:'USDJPY',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDCHF),
                    title:'USDCHF',
                    show:true
                },
                {
                    pair:pairTrue(this.position.EURGBP),
                    title:'EURGBP',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDCAD),
                    title:'USDCAD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.AUDUSD),
                    title:'AUDUSD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.NZDUSD),
                    title:'NZDUSD',
                    show:true
                }
            ];
            return positionPair;
        },
        getCounter() {
            let pairCounts = []
            for(let i = 0; i < this.currencyForCounters.length; i++)
            {
                let data = null;
                if(this.$store.getters["positions/getPositionsBySymbol"](this.currencyForCounters[i]) === undefined) {
                   data = 0;
                   pairCounts.push(0)
                } else {
                    data = this.$store.getters["positions/getPositionsBySymbol"](this.currencyForCounters[i]);
                    pairCounts.push(data.length)
                }

            }
            return pairCounts;
        },
        deltaBalance()
        {
        return (this.lastDailyBalance1 - this.lastDailyBalance0) / this.lastDailyBalance0 * 100
        },
        deltaEquity()
        {
            return (this.summaryEquity - this.lastDailyEquity ) / this.summaryEquity * 100
        },
        getNavigator()
        {
            return this.navigator
        }
    },
    methods: {
        slideTabs(status){
            this.autoTabs = status;
            if(this.autoTabs) {
                this.interval = setInterval(() => {
                    let arrayKeys = [];
                    for(let key in this.$refs) {
                        arrayKeys.push(this.$refs[key].isActive)
                    }
                    let index = arrayKeys.indexOf(true);
                    if (index !== -1 && index !== arrayKeys.length - 1) {
                        arrayKeys[index] = false;
                        arrayKeys[index + 1] = true;
                    }
                    else {
                        arrayKeys[arrayKeys.length - 1] = false;
                        arrayKeys[0] = true;
                    }
                    this.$refs.profit.isActive = arrayKeys[0];
                    this.$refs.plus.isActive = arrayKeys[1];
                    this.$refs.gistogramm.isActive = arrayKeys[2];
                    this.$refs.pairs.isActive = arrayKeys[3];
                    this.$refs.prognosis.isActive = arrayKeys[4];
                    this.$refs.compare.isActive = arrayKeys[5];
                    this.$refs.week.isActive = arrayKeys[6];
                    this.$refs.month.isActive = arrayKeys[7];
                }, 20000);
            }
            else {
                clearInterval(this.interval);
            }
        },
        fullscreen() {
            if(this.fullScreen)
            {
                this.leftNavigator= true;
                this.subContent = true;
                this.fullScreen = false;
            }
            else {
                this.leftNavigator = false;
                this.subContent = false;
                this.fullScreen = true;
            }
        },
        switchRightChat () {
            this.rightChat = !this.rightChat
        },
        showNews() {
            this.rightChatWidget = false;
            this.rightNews = true;
        },
        showRightChat() {
            this.rightChatWidget = true;
            this.rightNews = false;
        },
        switchChat () {
            this.navTab = false;
        },
        switchInstruments () {
            this.navTab = true;
        },
        setSatusLeftNavigator(e) {
            this.showLeftNavigator(e);
        },
        showLeftNavigator(e) {
            if(e === '+' || e === 'ДЕНЬ' || e == 'Доход инвестора') {
                this.leftNavigator = false;
                this.statusNavigator = this.leftNavigator;
                this.resize = false;
            } else if(e != '+') {
                this.leftNavigator = true;
                this.statusNavigator = this.leftNavigator;
                this.resize = true;
            }

        },
        onShowSubContent() {
            this.subContent = !this.subContent
        },
        navMenuSwitcher() {
            this.navMenu = !this.navMenu;
            this.overlayNavigator = true;
        },
        closeMenu() {
            this.navMenu = false;
            this.overlayNavigator = false;
        },
        switchSelector(status,index) {
            this.navigator[index].statusActive = status;
            //let data = {index:index, show:status}
            //this.$store.dispatch('usersets/saveSettingsNavigatorShowItem', data);
        },
        onDataPrognosisMonth(data) {
            this.prognosisMonth = data;
        },
        onDataPrognosisSison(data) {
            this.prognosisSison = data;
        },
        onDataPrognosisSixMonth(data) {
            this.prognosisSixMonth = data;
        },
        onDataPrognosisYear(data) {
            this.prognosisYear = data;
        },
        proccesStatisticReady(symbol){
            let stat = this.$store.getters["accountstat/getStatistics"](symbol);
            this.statPrimary = stat;
            this.lastPlAbs = this.statPrimary.Summary.ProfitAbs;
            this.summaryEquity = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityClose;
            this.summaryBalance = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].BalanceClose;
            this.lastDailyEquityMax = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityHigh;
            this.lastDailyEquityMin = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityLow;
            this.lastDailyEquity = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityOpen;
            this.lastDailyBalance1 = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].BalanceClose;
            this.lastDailyBalance0 = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].BalanceClose;
            this.lastDailyLeverage = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].Leverage;
            this.lastDailyLeverageMax = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].LeverageHigh;
            this.leverageMax = this.statPrimary.Summary.MaxLeverage;
            this.dd = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].Drawdown
        },
        setSorting() {
            this.$store.dispatch('usersets/saveSettingsNavigatorItem', this.navigator)
        }
    },
    watch: {
        statusLeftNavigator: function() {
            this.showLeftNavigator();
        }
    },
    created() {
        this.$store.dispatch('chat/enterRoom', 0);
        this.navigator = this.getStatusHeader.navigator
    }
}
</script>

<style lang="less" scoped>
.grid {
    height: calc(100vh - 220px);
    &-pair {
       height: calc(100vh - 220px);
       &-full {
           height: calc(100vh - 221px);
       }
    }
    &-month {
       min-height: calc(100vh - 291px);
       //overflow: scroll;
    }
    &-full {
       height: calc(100vh - 180px);
    }
}
.fullScreen {
    position: absolute;
    top: 0;
    right: 12px;
    height: 40px;
    font-size: 23px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.autoSwitchTabs {
    position: absolute;
    top: 0;
    right: 38px;
    height: 40px;
    font-size: 23px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &__text {
        font-family: Arimo;
        font-size: 10px;
        margin-right: 4px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
    }
}
.prognosi-row {
    display: flex;
    width: 100%;
}
.prognosis-wrap {
    margin-bottom:4px;
}
.overlay-navigator {
    position: absolute;
    top:0;
    right: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2;
}
.navigator {
    &_tab {
        max-height: 96%;
        overflow: auto;
        padding-bottom: 5px;
    }
    &__head {
        display: flex;
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.64;
        letter-spacing: 0.4px;
        color: #ffffff;
        max-height: 40px;
    }
    &__chat {
            display: block;
            height: ~"calc(100vh - 138px)";
            &-minimaze {
                display: block;
                height: ~"calc(100vh - 90px)"
            }
    }
    &__wrap {
        position: relative;
        height: 100%;
        &-minimaze {
            display: block;
            //height: ~"calc(100vh - 92px)"
        }
    }
    &__widget {
        //position: absolute;
        display: block;
        width: 360px;
        //overflow: auto;
        //max-height: calc(100vh - 138px);
    }
    &__menu {
        position: absolute;
        width: 260px;
        display: block;
        background-color: #506b89;
        border-radius: 4px;
        overflow: hidden;
        z-index: 3;
        box-shadow: 0px 8px 15px 5px rgba(0, 0, 0, 0.2);
    }
    &__item-active {
        max-height: 40px;
        border-top: 1px solid #465f7a;
        cursor: pointer;
        overflow: hidden;
        display: flex;
        align-items: center;

        div.navigator__text {
        margin-left: 0px;
        }
    }
    &__icon {
        margin: 0px 12px;
        padding-top: 7px;
        cursor: pointer;

		&-chat {
			padding-top: 0;
		}
    }
    &__title {
        text-transform: uppercase;
        cursor: pointer;
        font-family: 'Arimo';
        color:#fff;
        &-chat {
            display: flex;
            padding: 0 12px;
            &-text {
                cursor: pointer;
                text-transform: uppercase;
            }
        }
    }
    &__instruments {
        display: flex;
        flex-grow: 1;
        max-width: 50%;
        border-right: 1px solid #293546;
    }
}
.navigator__close-ico {
    position: absolute;
    font-size: 23px;
    height: 40px;
    display: flex;
    align-items: center;
    right: 0;
    padding-right: 8px;
    cursor:pointer;
    z-index: 1;
}
.navigator-mini {
    max-width: 40px;
}
.chart-wrapper {

  &__prognosis {
    //display: flex;
    margin-bottom: 0px;
    overflow: hidden;
    flex-grow: 1;
    background: #324258;
    border-right: 1px solid #324258;
  }
}

.chart-wrapper .chart__part-one .chart__title {
  border-radius: 4px 0 0 0;
}

.chart-main-wrap {
    &_prognosis {
        flex-grow: 1;
        width: 100%;
        position: relative;
    }
}

.chart__chart-wrap-down
{
    background-image: linear-gradient(to top, rgba(255, 146, 146, 0.1), rgba(255, 146, 146, 0.2));
    min-height: 128px;
    overflow: hidden;
    margin-bottom: 1px;

    .chart__chart
    {
        display: flex;
        min-height: 128px
    }
}

.round-title {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    margin-right: 4px;
}
.chart-wrapper .chart__part-one .chart-main-wrap {
  background-color: #3d536b;
}
.chart__inf {
    &-section-one {
        display: flex;
        &-left {

        }
        &-right {
            margin-left: 12px;
            width:100px;
        }
    }
}
.chart__inf-wrap {
  padding: 12px 12px 12px 12px;
  display: flex;
  justify-content: space-between;
  position: absolute;
  z-index: 1;
  &__prognosis {
      padding: 45px 92px 12px 12px;
        display: flex;
        justify-content: space-between;
        position: absolute;
        z-index: 1;
  }
}
.chart__chart-wrap {
    display: flex;
    background-image: linear-gradient(
        to top,
        rgba(54, 226, 255, 0.4),
        rgba(0, 175, 255, 0)
    );
    min-height: calc(100vh - 569px);
    overflow: hidden;
    margin-bottom: 1px;
    flex-grow: 1;
    &__prognosis {
        display: flex;
        background-image: linear-gradient(to top, rgba(0, 247, 255, 0.2), rgba(0, 255, 208, 0));
        min-height: 244px;
        overflow: hidden;
        margin-bottom: 1px;
        flex-grow: 1;
    }
    &-week {
        background-color: #3d536b;
        background-image: none;
    }
}

.chart__chart-wrap-full {
    min-height: calc(100vh - 354px);
    &-prognosis {
        min-height: calc(100vh - 672px);
    }
}

.chart-wrapper .chart__part-two {
  min-width: 128px;
  margin-right: 1px;
}

.chart__inf-wrap {
  padding: 12px 12px 12px 12px;
  display: flex;
  justify-content: space-between;
  //width: ~"calc(100% - 92px)";
  position: absolute;

  &-item {
    margin-bottom: 0px;
    display: flex;

    &-prognosis {
        display: block;

    }

    &-title {
      font-family: Arimo;
      font-size: 10px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.6;
      letter-spacing: 0.4px;
      color: #aabed2;
      text-transform: uppercase;
      margin-right: 4px;
    }
  }
}
.chart__inf-wrap-item-data-prognosis {
    font-family: Arimo;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color:#00ffd0;
    &-round{
            width: 80px;
        }
}
.chart__inf-wrap-item-data-green-sum {
  font-family: Arimo;
  font-size: 13px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.27;
  letter-spacing: 0.4px;
  text-align: left;
  color: #00ffd0;
  margin-right: 8px;
  max-height: 16px;
}

.chart__inf-wrap-item-data-red-sum {
  font-family: Arimo;
  font-size: 13px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.27;
  letter-spacing: 0.4px;
  text-align: left;
  color: #ff9292;
  max-height: 16px;
}

.chart__inf-wrap-item-data-green-pips {
  font-family: Arimo;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.27;
  letter-spacing: 0.4px;
  color: #0fd7b7;
  margin-right: 8px;
  max-height: 16px;
}

.chart__inf-wrap-item-data-white {
  font-family: Arimo;
  font-size: 13px;
  //font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.27;
  letter-spacing: 0.4px;
  text-align: left;
  color: #ffffff;
  max-height: 16px;
}

.main-head-chat {
    display: flex;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #ffffff;
    max-height: 40px;
    background-color: #324258;
    &__title {
        text-align: center;
        flex-grow: 1;
        flex-basis: 50%;
        cursor: pointer;
        span {
            color:#adc7e1;
        }
        &-active {
            border-bottom: 1px solid #00ffd0;
        }
        &-news {
            margin-right: 0px;
            cursor: pointer;
            margin-left: auto;
        }
    }
    &__text {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.64;
        letter-spacing: 0.4px;
        text-align: right;
        color: rgb(173, 196, 225);
        margin-left: 12px;
    }
}
.right-block {
    display: block;
    width: 400px;
}
.right-block-widgets-wrap {
     height: calc(100vh - 140px);

     &-minimaze {
        height: calc(100vh - 92px);

     }
}

.chart-wrapper .chart__part-three {
  min-width: 220px;
}

@media screen and (max-width: 1366px) {
  .chart-wrapper .chart__part-three {
    min-width: 180px;
  }
}
@media screen and (max-width: 1366px) {
  .chart-wrapper .chart__part-two {
    min-width: 180px;
  }
}
@media screen and (min-width: 1599px) {
    .navigator__title-chat {
        display: none;
    }
    .navigator__instruments {
        border-right: none;
    }
}
@media screen and (min-width: 2240px) {
      .chart__chart-wrap {
      min-height: 700px;
      }
  }
.statistica__per-month-preloader {
    width: 100%;
    min-height: calc(100vh - 291px);
    display: flex;
    justify-content: center;
    align-items: center;
}
//Preloader animations
.lds-ring {
    display: inline-block;
    position: relative;
    z-index: 1;
    width: 64px;
    height: 64px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
}
//Navigator animation

@keyframes navigatorMinimazeWidth {
    from {
        max-width: 360px;
    }
    to {
        max-width: 40px;
    }
}

@keyframes navigatorFullWidth {
    from {
        max-width: 40px;
    }
    to {
        max-width: 360px;
    }
}
.navigatorMinimaze {
    animation: navigatorMinimazeWidth 1.6s;
    max-width: 40px;
}
.navigatorFull {
    //animation: navigatorFullWidth 1.6s;
    max-width: 360px;
}
.navigatorFull-anim {
    animation: navigatorFullWidth 1.6s;
    max-width: 360px;
}
</style>
